module.exports = __webpack_public_path__ + "img/Health & Beauty_Recall_3_Set.a8d477c6.png";